import Head from 'next/head';
import React from 'react';

export default function About() {
  return (
    <>
      <Head>
        <title>About | frontendeval</title>
        <meta name="description" content="About frontendeval" />
        <meta property="og:title" content="About | frontendeval" />
        <meta property="og:description" content="About frontendeval" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_DOMAIN!}/about`}
        />
      </Head>
      <div className="container pt-10">
        <div className="mx-auto max-w-prose">
          <h2 className="h3 mb-4">What’s this site?</h2>
          <p className="mb-8">
            This site is a repository of questions for frontend engineer job
            seekers looking to test themselves prior to going into interviews
            (or if you’re just looking for a challenge to level up your skills).
          </p>

          <h2 className="h3 mb-4">
            What makes this site different from other interview prep resources?
          </h2>
          <p className="mb-4">
            At many companies, algorithmic interview questions have fallen out
            of favor when hiring frontend engineers. The reason is obvious:
            these questions are nearly worthless when it comes to evaluating how
            well a frontend engineer can do their job. Companies have begun
            shifting towards practical questions that test actual frontend
            skills, like implementing UIs, creating interactive features, doing
            so in an accessible and performant way, etc.
          </p>

          <p className="mb-8">
            While the evolution towards more practical evaluation is generally a
            positive trend, it doesn’t help you much when it comes to your
            interview prep. Most interview prep resources are geared towards
            algorithmic interviews. Usually the most you’ll get is that you can
            do the algorithmic interview exercises in JavaScript/TypeScript.
            This site is built to give you practice with more of the practical
            exercises you’ll encounter in modern frontend interviews.
          </p>
        </div>
      </div>
    </>
  );
}
